<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors'"
            >Investors</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Update
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <investor-form
        formType="update"
        :activeInvestorID="activeInvestorID"
        @saveInvestor="updateInvestor"
      ></investor-form>
    </div>
  </div>
</template>
<script>
import InvestorForm from "./forms/investorForm.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
      activeInvestorID: null,
    };
  },
  created: function () {
    this.activeInvestorID = this.$route.params.investorId;
  },
  components: {
    InvestorForm,
  },
  methods: {
    formValidation(investor) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";
      if (investor.first_name.length < 2) {
        missingFieldsString +=
          "Investor first name is less than 2 characters, ";
        result.isValid = false;
      }
      if (investor.last_name.length < 2) {
        missingFieldsString += "Investor last name is less than 2 characters, ";
        result.isValid = false;
      }
      if (!investor.home_address) {
        missingFieldsString += "Investor home address field is empty, ";
        result.isValid = false;
      }
      if (!investor.mobile_number) {
        missingFieldsString += "Investor mobile number field is empty, ";
        result.isValid = false;
      }
      if (!investor.date_of_birth) {
        missingFieldsString += "Investor date birth is not selected, ";
        result.isValid = false;
      }
      if (!investor.date_of_birth) {
        missingFieldsString += "Investor date birth is not selected, ";
        result.isValid = false;
      }
      let genderList = [0, 1, null];
      if (!genderList.includes(investor.gender)) {
        missingFieldsString += "Project gender should be selected, ";
        result.isValid = false;
      }
      let maritalStatusList = ["single", "married", "divorced", "widowed"];
      if (!maritalStatusList.includes(investor.marital_status)) {
        missingFieldsString += "Project marital status should be selected, ";
        result.isValid = false;
      }
      if (!investor.nationality_id) {
        missingFieldsString += "Investor nationality is not selected, ";
        result.isValid = false;
      }
      if (!investor.country_of_residence_id) {
        missingFieldsString +=
          "Investor country of residence is not selected, ";
        result.isValid = false;
      }
      if (!investor.pasport_id) {
        missingFieldsString += "Investor passport id field is empty, ";
        result.isValid = false;
      }
      if (!investor.emergency_contact_name) {
        missingFieldsString +=
          "Investor emergency contact name field is empty, ";
        result.isValid = false;
      }
      if (!investor.emergency_contact_number) {
        missingFieldsString +=
          "Investor emergency contact number field is empty, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    updateInvestor(investor) {
      const { isValid, message } = this.formValidation(investor);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("updateInvestor", investor);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      updatedInvestor: (state) =>
        state.investorStore.investorUpdate.updatedInvestor,
      updateInvestorStatus: (state) =>
        state.investorStore.investorUpdate.updateInvestorStatus,
      updateInvestorStatus: (state) =>
        state.investorStore.investorUpdate.updateInvestorStatus,
      deleteInvestorStatus: (state) =>
        state.investorStore.investorDelete.deleteInvestorStatus,
    }),
  },
  watch: {
    updateInvestorStatus() {
      if (this.updateInvestorStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Investor has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/investors");
        });
      } else if (this.updateInvestorStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Investor update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/updateInvestor.vue